import { Injectable } from "@angular/core";
import { IFlaggedAns, ICommentField } from "./subcategory";
import { BehaviorSubject } from "rxjs";
import { subcategoryTabs } from "./subcategory.const";
@Injectable()
export class TaxReturnSubcategoryService {
  flaggedAnsChanged = new BehaviorSubject<IFlaggedAns>(null);
  private flaggedAns: IFlaggedAns;


  commentFieldsChanged = new BehaviorSubject<ICommentField[]>([]);
  private commentFields: ICommentField[];

  currentTab = subcategoryTabs.comments;

  constructor() { }
  getFlaggedAns() {
    return this.flaggedAns;
  }
  setFlaggedAns(flaggedAns: IFlaggedAns) {
    this.flaggedAns = flaggedAns;
    this.flaggedAnsChanged.next(flaggedAns);
  }

  getCommentFields(): ICommentField[] {
    return this.commentFields;
  }

  setCommentFields(commentFields: ICommentField[]) {
    this.commentFields = commentFields;
    this.commentFieldsChanged.next(this.commentFields);
  }

  addCommentField(commentField: ICommentField) {
    if (!this.commentFieldExist(commentField)) {
      this.commentFields.push(commentField);
      this.commentFieldsChanged.next(this.commentFields);
    }
  }

  removeCommentField(commentField: ICommentField) {
    if (this.commentFieldExist(commentField)) {
      this.commentFields = this.commentFields.filter(cf => {
        return cf.id !== commentField.id || cf.groupId !== commentField.groupId || cf.rowIndex != commentField.rowIndex;
      });
      this.commentFieldsChanged.next(this.commentFields);
    }
  }

  removeCommentFieldsByGroup(groupId: number) {
    this.commentFields = this.commentFields.filter(cf => cf.groupId !== groupId);
    this.commentFieldsChanged.next(this.commentFields);
  }

  commentFieldExist(commentField: ICommentField): boolean {
    return this.commentFields.some(cf => {
      return cf.id === commentField.id && cf.groupId === commentField.groupId && cf.rowIndex === commentField.rowIndex;
    });
  }


  selectTab(tab) {
    this.currentTab = tab;
  }

}